import React from 'react'

export const BorderBottamIcon = () => {
  return (
    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_648_1593" fill="white">
        <path d="M50.332 40.1261C50.332 45.6489 45.8549 50.1261 40.332 50.1261H0.332031V0.126099H50.332V40.1261Z" />
      </mask>
      <path d="M51.332 40.1261C51.332 46.2012 46.4072 51.1261 40.332 51.1261H0.332031V49.1261H40.332C45.3026 49.1261 49.332 45.0967 49.332 40.1261H51.332ZM0.332031 0.126099H50.332H0.332031ZM51.332 0.126099V40.1261C51.332 46.2012 46.4072 51.1261 40.332 51.1261V49.1261C45.3026 49.1261 49.332 45.0967 49.332 40.1261V0.126099H51.332ZM0.332031 50.1261V0.126099V50.1261Z" fill="black" mask="url(#path-1-inside-1_648_1593)" />
    </svg>
  )
}
